export const UserRole = {
  Admin: 0,
  Editor: 1,
};

/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default';

export const layouts = {
  '/app':'AppLayout',
  '/home':'HomeLayout'
}

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'en';
export const localeOptions = [
  { id: 'en', name: 'English - LTR', direction: 'ltr' },
  { id: 'es', name: 'Español', direction: 'ltr' },
  { id: 'enrtl', name: 'English - RTL', direction: 'rtl' },
];

export const firebaseConfig = {
  apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
  authDomain: 'gogo-react-login.firebaseapp.com',
  databaseURL: 'https://gogo-react-login.firebaseio.com',
  projectId: 'gogo-react-login',
  storageBucket: 'gogo-react-login.appspot.com',
  messagingSenderId: '216495999563',
};

export const userAccess = {
  
  getPageItems:(acs,clicked,cp) => {
    var resp = {networkConnections:false};
    if (clicked.isConnection){
        resp.pageItems = Object.keys(cp[clicked.account]).map((cii) => {var ci = cp[clicked.account][cii];ci.isParent=true;ci.accountLabel = clicked.account;ci.account = clicked.account;ci.name=ci.generic.name;return ci;});
        resp.networkConnections = cp[clicked.account];
    }else{
    
      if (clicked.isLabel){resp.pageItems = acs[clicked.account];return resp;}
      switch(clicked.accountLabel){
        case "Network":
          resp.pageItems = acs.Dashboard.map((d)=>{return d.network && d.network.documentId == clicked.documentId ? d : false}).filter(a=>a);
          resp.networkConnections = (clicked.networkConnections) ? clicked.networkConnections : networkConnections;
          break;
        case "Dashboard":
          resp.pageItems = (clicked.network && clicked.network.configuration.connections) ? Object.keys(clicked.network.configuration.connections).map((c) => {
            return {account:c,isParent:true,accountType:c,name:c,isLabel:true,isConnection:true,generic:{name:c,id:c,subTitle:c,isParent:true}}
          }) : [];
          break;

        case "Google":
          resp.networkConnections = clicked;
          resp.pageItems = (clicked.Adwords) ? Object.keys(clicked.Adwords).map((c) => {
            var o = {...clicked.Adwords[c],...clicked.Adwords[c].generic};
                o.id = c;
                o.account = "Adwords";
                o.isParent = o.Adwords ? true : false;
                o.name = o.generic.name;
                o.accountLabel = "Adwords";
            return o;
          }) : [];
          break;
        case "Adwords":
            resp.pageItems = (clicked.Adwords) ? Object.keys(clicked.Adwords).map((c) => {
            var o = {...clicked.Adwords[c],...clicked.Adwords[c].generic};
                o.id = c;
                o.account = "Adwords";
                o.name = o.generic.name;
                o.isParent = o.Adwords ? true : o.Campaign ? true : false;
                o.accountLabel = "Adwords";
            return o;
          }) : [];
          resp.pageItems = (clicked.Campaign) ? resp.pageItems.concat(Object.keys(clicked.Campaign).map((c) => {
            var o = {...clicked.Campaign[c],...clicked.Campaign[c].generic};
                o.id = c;
                o.account = "Campaign";
                o.name = o.generic.name;
                o.isParent = false;
                o.accountLabel = "Campaign";
            return o;
          })) : resp.pageItems;
          break;
      }
    }
      return resp;
  },
  items:[
  {account:"Network",isParent:true,accountType:"Network",name:"Networks",isLabel:true,generic:{name:"Networks",id:1,subTitle:"Assign Network Dashboards",isParent:true}},
  {account:"Dashboard",isParent:true,accountType:"Dashboard",name:"Dashboards",isLabel:true,generic:{name:"Dashboards",id:1,subTitle:"Assign Dashboards",isParent:true}},
  ]
}

export const currentUser = {
  id: 1,
  title: 'Sarah Kortney',
  img: '/assets/img/profiles/l-1.jpg',
  date: 'Last seen today 15:24',
  role: UserRole.Admin,
};

export const adminRoot = '/app';
export const buyUrl = 'https://1.envato.market/k4z0';
export const searchPath = `${adminRoot}/pages/miscellaneous/search`;
export const servicePath = 'https://api.coloredstrategies.com';

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light.purplemonster';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
];

export const tooltips = {
  fields:{
    "networkType":{
    "managed":{title:"Managed Network",tip:"A network of campaigns managed by you or an agency in which multiple user dashboards are created and assigned to taylored data views."},
    "subscribed":{title:"Subsribed Network",tip:"A smaller network of campaigns created by you for your business"}
    }
  }
}